<div (keyup.enter)="signIn$.next()" class="w-full md:mt-0 sm:max-w-md xl:p-0">
  <div class="login-form__card">
    <h1 class="login-form__card-title text-center">
      {{ 'auth.signIn' | transloco }}
    </h1>
    <div class="space-y-4 md:space-y-6">
      <div>
        <tui-input [formControl]="form.controls.login" tuiTextfieldSize="l">
          {{ 'auth.login' | transloco }}
          <input tuiTextfield type="email" />
        </tui-input>
      </div>
      <div>
        <label class="login-form__card-label"></label>
        <tui-input-password
          [formControl]="form.controls.password"
          tuiTextfieldSize="l"
        >
          {{ 'auth.password' | transloco }}
        </tui-input-password>
      </div>

      <button
        [showLoader]="(loading$ | async)!"
        (click)="signIn$.next()"
        size="l"
        class="w-full"
        appearance="primary"
        tuiButton
      >
        {{ 'auth.signIn' | transloco }}
      </button>
    </div>
  </div>
</div>
